import React from 'react';
import Icon from '../../common/Icons';
import AdminPersonnelModal, { ModalDetailField, ModalFooterActions } from '../ui/AdminPersonnelModal';
import AffiliationBadge from '../../companies/AffiliationBadge';
import '../../companies/AffiliationBadge.css';

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('fr-FR');
};

const CompanyDetailsModal = ({ show, onHide, company, onEdit, affiliationRef = null }) => {
  if (!company) {
    return (
      <AdminPersonnelModal
        show={show}
        onHide={onHide}
        size="lg"
        icon="building"
        badge="Fiche"
        title="Détails société"
        ariaLabelledBy="ap-company-detail-title"
      />
    );
  }

  return (
    <AdminPersonnelModal
      show={show}
      onHide={onHide}
      size="lg"
      icon="building"
      badge="Fiche société"
      title={company.name}
      subtitle="Informations en lecture seule"
      ariaLabelledBy="ap-company-detail-title"
      footer={
        <ModalFooterActions
          onCancel={onHide}
          cancelLabel="Fermer"
          primary={
            <button
              type="button"
              className="ap-modal-btn ap-modal-btn--edit"
              onClick={() => {
                onEdit(company);
                onHide();
              }}
            >
              <Icon name="edit" size={14} />
              Modifier
            </button>
          }
        />
      }
    >
      <div className="ap-modal-hero">
        <div className="ap-modal-hero__main">
          <h3 className="ap-modal-hero__title">{company.name}</h3>
          <p className="ap-modal-hero__sub">{company.city || 'Ville non renseignée'}</p>
        </div>
        <span
          className={`ap-modal-status ${
            company.is_active ? 'ap-modal-status--active' : 'ap-modal-status--inactive'
          }`}
        >
          <Icon name={company.is_active ? 'checkCircle' : 'times'} size={14} />
          {company.is_active ? 'Active' : 'Inactive'}
        </span>
      </div>

      <div className="ap-modal-detail">
        <ModalDetailField label="Code société">
          <span className="ap-modal-detail__value--strong co-company-code">
            {company.company_code || '—'}
          </span>
        </ModalDetailField>
        <ModalDetailField label="Affiliation SMIE" fullWidth>
          <AffiliationBadge affiliation={affiliationRef} variant="stacked" />
        </ModalDetailField>
        <ModalDetailField label="Adresse" fullWidth>
          <span className="ap-modal-detail__value--strong">{company.address || '—'}</span>
        </ModalDetailField>
        <ModalDetailField label="Ville">{company.city || '—'}</ModalDetailField>
        <ModalDetailField label="Téléphone">{company.phone || '—'}</ModalDetailField>
        <ModalDetailField label="Email" fullWidth>
          {company.mail || '—'}
        </ModalDetailField>

        <div className="ap-modal-detail__meta">
          <ModalDetailField label="Créée le">{formatDate(company.created_at)}</ModalDetailField>
          <ModalDetailField label="Dernière modification">
            {formatDate(company.updated_at)}
          </ModalDetailField>
        </div>
      </div>
    </AdminPersonnelModal>
  );
};

export default CompanyDetailsModal;
